<page-heading
  [title]="'tracking.home.title' | translate"
  [description]="'tracking.home.description' | translate"
/>

<div class="card">
    <div class="track-card" (click)="viewReportTracking()">
      <div class="track-card-icon">
        <i class="ri-map-pin-line"></i>
      </div>
      <div class="track-card-info">
        <h5>{{ 'tracking.home.cardTitle' | translate }}</h5>
        <span>{{ 'tracking.home.cardSubtitle' | translate }}</span>
      </div>
    </div>
</div>
